module.exports = __webpack_public_path__ + "resources/img/ico-company-aboutteam-ifg-1@2x.2e183aa1.png";